<template>
  <div class="carrot">
      <div class="main-wrapper">
          <Menu></Menu>
          <div class="page-wrapper">
              <div class="page-content">
                  <div class="row">
                      <div class="col-xl-12">
                            <h3 class="page-title">교재 관리</h3>
                            <p class="lead">
                                <span>- CARROT의 교재를 관리하는 페이지입니다.</span> <br/>
                                <span>- 교재등록 시 등록 버튼을 클릭하여 등록해 주세요.</span> <br/>
                                <span>- 교재 명 클릭 시 해당 교재의 상세 정보와 교재 버전 내역을 확인 할 수 있습니다.</span> <br/>
                                <span>- 리스트에는 최신 버전만 노출됩니다.</span>
                            </p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-12 grid-margin stretch-card">
                          <div class="card">
                              <div class="card-body">
                                    <div class="clear">
                                        <div class="form-group float-left clear w-100per">
                                            <table class="table table-bordered">
                                                <tr>
                                                    <th>등록일</th>
                                                    <td colspan="3">
                                                        <input v-model="searchObject.startDate" type="date"> - <input v-model="searchObject.endDate" type="date">
                                                    </td>

                                                    <th>언어</th>
                                                    <td colspan="3">
                                                        <select name="selYear" class="form-control fl w-100" v-model="searchObject.ebookLanguage">
                                                                <option value="">언어 전체</option> 
                                                                <option value="영어">영어</option>
                                                                <option value="중국어">중국어</option>
                                                                <option value="일본어">일본어</option>
                                                                <option value="스페인어">스페인어</option>
                                                                <option value="기타 외국어">기타 외국어</option>
                                                        </select>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>교재명</th>
                                                    <td colspan="3">
                                                        <input type="text" class="form-control w-100 fl" placeholder="검색어를 입력해 주세요" v-model="searchObject.ebookName">
                                                    </td>

                                                    <th>ISBN</th>
                                                    <td colspan="3">
                                                        <input type="text" class="form-control w-100 fl" v-model="searchObject.ebookIsbn" placeholder="ISBN을 입력해 주세요" >
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>학습영역</th>
                                                    <td colspan="3">
                                                        <select class="form-control fl w-100" v-model="searchObject.ebookStudyArea">
                                                            <option value="">학습 영역 전체</option> 
                                                            <option value="회화">회화</option>
                                                            <option value="작문">작문</option>
                                                            <option value="청취">청취</option>
                                                            <option value="독해">독해</option>
                                                            <option value="문법">문법</option>
                                                            <option value="어휘">어휘</option>
                                                            <option value="발음">발음</option>
                                                        </select>
                                                    </td>

                                                    <th>레벨</th>
                                                    <td colspan="3">
                                                        <select name="selYear" class="form-control fl w-100" v-model="searchObject.ebookLevel">
                                                            <option value="">레벨 전체</option> 
                                                            <option value="초급">초급</option>
                                                            <option value="중급">중급</option>
                                                            <option value="고급">고급</option>
                                                        </select>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>카테고리</th>
                                                    <td colspan="12">
                                                        <div class="category">
                                                            <div class="code-box" v-for="(item,index) in categoryList" :key="index">
                                                                <input :id="item.categoryCode" :value="item.categoryCode"  v-model="codeEbookCategoryArray" type="checkbox">
                                                                <label :for="item.categoryCode">{{ item.name }}</label>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <button class="btn btn-primary fr ml-10 mb-3" @click="search()">검색</button>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-12 grid-margin stretch-card">
                          <div class="card">
                              <div class="card-body">
                                  <div class="clear mb-2">
                                       <select name="selYear" class="form-control fl w-10" v-model="searchObject.ebookUseStatus" @change="search()">
                                                <option value="">사용 유무 전체</option> 
                                                <option value="사용">사용</option>
                                                <option value="사용 안함">사용 안함</option>
                                        </select>

                                        <select name="selYear" class="form-control fl w-10 ml-10" v-model="searchObject.ebookExposureSystem" @change="search()">
                                                <option value="">시스템 전체</option> 
                                                <option value="공용">공용</option>
                                                <option value="CTM">CTM</option>
                                                <option value="ITM">ITM</option>
                                        </select>
                                        
                                        <button class="btn btn-primary fr ml-10" @click="excelDownload()">엑셀 다운로드</button>
                                        <button class="btn btn-primary fr ml-10" @click="goOtherPage('/book/bookAdd')">교재 등록하기</button>

                                  </div>
                                 

                                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                                      <table class="table table-bordered mt-15">
                                          <tbody v-if="ebookList.length >0">
                                                <tr align="center" height="25">
                                                    <th class="w-4per">No</th>
                                                    <th class="w-5per">ISBN</th>
                                                    <th class="w-7per">노출 <br>시스템</th>
                                                    <th class="w-7per">언어</th>

                                                    <th class="w-20per">카테고리</th>
                                                    <th class="w-7per">학습영역</th>
                                                    <th class="w-7per">레벨</th>
                                                    <th>교재 명</th>

                                                    <th class="w-4per">버전</th>
                                                    <th class="w-7per">등록일</th>
                                                    <th class="w-7per">최근 <br> 업데이트일</th>
                                                    <th class="w-10per">사용유무</th>
                                                </tr>

                                                <tr  v-for="(item, index) in ebookList" :key="index">
                                                    <td>{{ item.rownum}}</td>
                                                    <td>{{ item.ebookIsbn}}</td>
                                                    <td>{{ item.ebookExposureSystem}}</td>
                                                    <td>{{ item.ebookLanguage}}</td>

                                                    <td class="txt-left">{{ item.categoryText }}</td>
                                                    <td>{{ item.ebookStudyArea }}</td>
                                                    <td>{{ item.ebookLevel }}</td>
                                                    <td class="cursor txt-left" @click="goOtherPage(`/book/bookDetail/${item.ebookIdx}/${item.ebookVersion}`)">{{ item.ebookName }}</td>

                                                    <td>{{ item.ebookVersion }}</td>
                                                    <td>{{ item.ebookCreateDate | dateformat(item.ebookCreateDate) }}</td>
                                                    <td>{{ item.ebookUpdateDate | dateformat(item.ebookUpdateDate) }}</td>
                                                    <td>{{ item.ebookUseStatus }}</td>
                                                </tr>
                                          </tbody>
                                          
                                          <tbody v-else>
                                              <tr align="center" height="25">
                                                <th class="w-5per">No</th>
                                                <th class="w-5per">ISBN</th>
                                                <th class="w-5per">노출 시스템</th>
                                                <th class="w-5per">언어</th>

                                                <th class="w-5per">카테고리</th>
                                                <th class="w-5per">학습영역</th>
                                                <th class="w-5per">레벨</th>
                                                <th class="w-10per">교재 명</th>

                                                <th class="w-5per">버전</th>
                                                <th class="w-5per">등록일</th>
                                                <th class="w-5per">최근 업데이트일</th>
                                                <th class="w-5per">사용유무</th>
                                            </tr>
                                            <tr>
                                                <td colspan="99">
                                                    검색 결과가 없습니다.
                                                </td>
                                            </tr>
                                          </tbody>
                                      </table>
                                  </div>
                                  <div v-if="ebookList.length > 0" style="padding-left:40%; padding-top:20px;">
                                      <paginate :page-count="lastpage" :page-range="3" :margin-pages="2"
                                                :click-handler="clickCallback" :prev-text="'Prev'"
                                                :next-text="'Next'" :container-class="'pagination'"
                                                :page-class="'page-link'">

                                      </paginate>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import Menu from '../../components/commons/incMenu';
import Paginate from 'vuejs-paginate';
import FileSaver from 'file-saver';
export default {
    name: 'bookList',
    data(){
        return{
            categoryList:[],
            codeEbookCategoryArray:[], // 카테고리 코드 배열
            searchObject: {
                startDate: '',
                endDate:'',
                ebookLanguage: '',
                ebookName: '',
                ebookIsbn:'',
                ebookStudyArea: '',
                ebookLevel:'',
                ebookCategory:'',
                pageNum:1,
                ebookUseStatus:'',
                ebookExposureSystem: ''
            },
            ebookList:[
            ],// 이북 리스트

            lastpage: 2,//마지막 페이지
        }
    },
    created(){
        this.selectCategories(); // 카테고리 데이터
    },
    components:{
        Menu,
        Paginate
    },
    methods: {
        /**
         * @description : 카테고리 데이터 호출
         */
        selectCategories(){
            this.axios.get('/v1/api/admin/category')
                .then(res=>{
                    console.log(res);
                    console.log(res.data);
                    this.categoryList = res.data.categories;
                    this.search();
                }).catch(err => {
                    if (err.response.data.path === '/login/msg') {
                        alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
                        this.$router.push('/login');
                    } else {
                        alert('관리자에게 문의하세요')
                    }
                })
        },
        /**
         * @description : 검색
         */
        search(){
            this.arrayToString(this.codeEbookCategoryArray);// array to string
            this.searchObject.pageNum = 1;
            this.getEbookList();
        },
        /**
         * @description : 이북리스트 조회
         */
        getEbookList(){
           this.axios.get("/api/v1/ebook/list",{params: this.searchObject})
           .then((res)=>{
               const { err,  ebookSize, ebookList} = res.data;
               if(err === 0){
                   this.ebookList = ebookList;
                   this.lastpage = Math.ceil(ebookSize/50);
               }
               else{
                   this.ebookList = [];
               }
           })
           .catch((err) => {
               console.error(`/api/v1/ebook/list error : `, err)
           });
        },

        /**
         * @description : array to string
         */
        arrayToString(obj){
            let str = '';
            if(Array.isArray(obj)){
                if(obj.length > 1){
                    obj.forEach((ele,index) => {
                        if(index === 0){
                            str+=ele;
                        }else{
                            str+=`|${ele}`;
                        }
                    });
                }
                else if(obj.length === 1){
                    str=obj[0];
                }
                this.searchObject.ebookCategory = str;
            }
        },

        /**
         * @description : paging call back
         */
        clickCallback(page){
            this.searchObject.pageNum = page;
            this.getEbookList();
        },

        /**
         * @description : 다른 페이지 이동
         */
        goOtherPage(path){
            // this.$router.push(path);
            let route = this.$router.resolve({path});
            window.open(route.href,"_blank");
        },

        /**
         * @description : 엑셀 다운로드
         */
        excelDownload(){
            this.arrayToString(this.codeEbookCategoryArray);// array to string
            const headers = {
                'Content-Type': 'ms-vnd/excel;charset=UTF-8'
            };

            const excelParams = {
                startDate: this.searchObject.startDate,
                endDate:this.searchObject.endDate,
                ebookLanguage: this.searchObject.ebookLanguage,
                ebookName: this.searchObject.ebookName,
                ebookStudyArea: this.searchObject.ebookStudyArea,
                ebookLevel:this.searchObject.ebookLevel,
                codeEbookCategory: this.searchObject.ebookCategory,
                ebookUseStatus: this.searchObject.ebookUseStatus,
                ebookExposureSystem: this.searchObject.ebookExposureSystem,
                idx:-1,
                pageNum:-1,
                pageSize:50,
            };
            this.axios.defaults.headers.post[headers];
            this.axios.get('/api/v1/ebook/excel', {
                params: excelParams,
                responseType: 'arraybuffer'
            })
            .then(res => {
                FileSaver.saveAs(new Blob([res.data]), "ebook_list.xlsx")
            }).catch(err => {
                console.error(err)
                alert('엑셀 다운로드에 실패하였습니다.')
            })
        }
    }
}
</script>

<style>
@import "../../../src/assets/scss/style.css";
@import "../../../src/assets/scss/commons/_style.css";
@import "../../../src/assets/scss/commons/_carrot.css";

.category{
    width: 70%;
}
input[type="checkbox"]{
 margin-top: 5px;
}
.code-box{
    min-width: 30%;
    display: inline-block;
}

.cursor{
    text-decoration: underline;
    cursor: pointer;
    color: #007bff;
}
</style>


// WEBPACK FOOTER //
// src/pages/book/bookList.vue